import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div<{ backgroundColor: string }>`
    display: flex;
    width: 100%;
    padding: 16px;
    background: ${(props) => `linear-gradient(${props.backgroundColor})`};
    border-radius: 16px;
    cursor: pointer;
`;

export const IconFlex = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

export const Icon = styled.div`
    display: flex;
    padding: 5px;
    align-items: center;
    text-align: center;
    border-radius: 8px;
`;

export const TextFlex = styled.div`
    display: flex;
    flex: 5;
    margin-left: 15px;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
`;

export const RightArrowFlex = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;
